import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { ProfileportfolioService } from '@tech-services/profileportfolio.service';
import { timer, Subject } from 'rxjs';
import { environment } from '@tech-environments/environment';
import { takeUntil } from 'rxjs/operators';
import { SessionService } from '@tech-services/session.service';
import { CommonService } from '@tech-services/common.service';
import { AppConfig } from '@tech-utils/app-config.service';
import { faSlidersH as fasSlidersH } from '@fortawesome/pro-solid-svg-icons';
import { faSlidersH as farSlidersH } from '@fortawesome/pro-regular-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { ModalCustomDateTradesComponent } from 'projects/apps/portal-client/src/app/shared/modal-custom-date-trades/modal-custom-date-trades.component';
import { MatDialog } from '@angular/material/dialog';
import { formatDate } from '@angular/common';
import { DeviceDetectorService } from '@techrules/portallib';

@Component({
  selector: 'tech-portfolio-trades',
  templateUrl: './portfolio-trades.component.html',
  styleUrls: [
    './portfolio-trades.component.scss',
    '../portfolio-data-shared-styles.scss',
  ],
})
export class PortfolioTradesComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();
  public tableMoreOfTen: boolean = false;
  public loadingTrades: boolean;
  private timer50 = timer(50);
  public cols: any;
  public dataTrades: any;
  public dataTradesTables: any;
  public arrTrades: any;
  public arrTradesTables: any;
  public productNamesFilter: any;
  public tradeNamesFilter: any;
  public selectedProductName: string;
  public selectedTrade: string;
  public tradesTablesIndex: number = 0;
  private listenerFnClicks: () => void;
  public isMobile: boolean;

  public panelOpenState: boolean = false;
  public fasSlidersH;
  public farSlidersH;
  minDate: string = '';
  maxDate: string = '';
  periodInitialDate = '';
  periodEndDate = '';
  TotalInitialDate = '';
  TotalEndDate = '';

  public dateFormat = this.sessionService.dateFormat
    .replace('DD', 'dd')
    .replace('YYYY', 'yyyy')
    .replace('MMM', 'MM');

  constructor(
    private commonService: CommonService,
    private profilePortfolioService: ProfileportfolioService,
    private renderer: Renderer2,
    private sessionService: SessionService,
    private translate: TranslateService,
    public dialog: MatDialog,
    private readonly deviceService: DeviceDetectorService
  ) {}

  @HostListener('window:resize') onresize() {
    this.isMobile = this.deviceService.isMobile();
  }

  ngOnInit() {
    this.isMobile = this.commonService.isMovilSource.getValue();
    this.selectedProductName = '0';
    this.selectedTrade = '0';
    this.loadingTrades = true;

  this.profilePortfolioService.portfolioanalysis$
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((res) => {
      this.TotalInitialDate = res.TotalInitialDate;
      this.TotalEndDate = res.TotalEndDate;
      this.maxDate = res.TotalEndDate; //res.PeriodEndDate;
      this.minDate = res.TotalInitialDate; //res.PeriodInitialtDate
      this.periodEndDate = res.TotalEndDate; //res.PeriodEndDate
      this.periodInitialDate = res.TotalInitialDate; //res.PeriodInitialtDate
      this.loadTrades();
    });
    
    this.profilePortfolioService.portfolioData$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.loadTrades();
      });
    this.profilePortfolioService.periodSelected$
       .pipe(takeUntil(this.unsubscribe$))
       .subscribe((res) => {
        //  this.maxDate = this.TotalEndDate; //res.PeriodEndDate;
        //  this.minDate = this.TotalInitialDate; //res.PeriodInitialtDate;
        //  this.periodEndDate = this.TotalEndDate; //res.PeriodEndDate;
        //  this.periodInitialDate = this.TotalInitialDate; //res.PeriodInitialtDate;
         this.profilePortfolioService.getTrades();
         this.selectedProductName = '0';
         this.selectedTrade = '0';
         this.loadingTrades = true;
         this.loadTrades();
       });
    this.profilePortfolioService.portfolioanalysisTrades$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        this.selectedProductName = '0';
        this.selectedTrade = '0';
        this.loadingTrades = true;
        this.loadTrades();
      });
    this.farSlidersH = farSlidersH;
    this.fasSlidersH = fasSlidersH;
  }

  ngAfterViewInit() {
    this.loadTrades();
    this.listenerFnClicks = this.renderer.listen(
      'document',
      'click',
      (event) => {
        if (event.target.classList.contains('assetProfile')) {
          let Code = event.target.getAttribute('data-code');
          let Id = event.target.getAttribute('data-id');
          localStorage.setItem('AssetCode', Code);
          localStorage.setItem('IsClient', '1');
          localStorage.setItem('AssetId', Id);
          localStorage.setItem('Domain', this.sessionService.domain);
          localStorage.setItem(
            'Token',
            localStorage.getItem('SessionClientToken')
          );
          var url =
            AppConfig.settings.angularAppsBase +
            '/asset?IsClient=1&ClientCode=' +
            localStorage.getItem('ClientCode') +
            '&AssetId=' +
            event.target.getAttribute('data-id') +
            '&Domain=' +
            localStorage.getItem('Domain') +
            '&Language=' +
            localStorage.getItem('Language') +
            '&SessionToken=' +
            localStorage.getItem('SessionClientToken');
          window.open(url, '_blank');
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
    if (this.listenerFnClicks) this.listenerFnClicks();
  }

  public loadTrades() {
    if (
      this.profilePortfolioService.portfolioanalysisTradesSource.getValue() !=
      undefined
    ) {
      this.loadingTrades = false;
      this.tableMoreOfTen = false;

      this.arrTrades =
        this.profilePortfolioService.portfolioanalysisTradesSource.getValue();

      /*
      arrTrades.push({
        Amount: 0.2,
        Code: 'EA5B442E249631C74A474FBBF30E373B',
        Commisions: 0.0,
        ContractCode: 'margen',
        Currency: 'USD',
        ExhangeRate: 1.0,
        Id: '-1',
        Isin: 'C$',
        NumberOfShares: 0.2,
        PriceCurrency: 'USD',
        ProductCode: 'C$',
        ProductName: 'CUENTA DE TRABAJO (USD)',
        QuotationType: 'P',
        TaxRegimeName: null,
        TradeCode: 'CANCELACION INT MEA',
        TradeDate: '2024-02-03',
        TradeName: 'Cancelacion intereses Mutuo Estructurado Activo',
        TradeNumber: '688255',
        TradePrice: 1.0,
        ValueDate: '2024-02-03',
        Withholdings: 0.0,
      });*/

      if (Object.keys(this.arrTrades).length !== 0) {
        this.productNamesFilter = this.arrTrades.filter((item, i, arr) => {
          return (
            arr.indexOf(arr.find((t) => t.ProductName === item.ProductName)) ===
            i
          );
        });
        this.tradeNamesFilter = this.arrTrades.filter((item, i, arr) => {
          return (
            arr.indexOf(arr.find((t) => t.TradeName === item.TradeName)) === i
          );
        });
        this.arrTrades = this.arrTrades.filter((objeto) => {
          const fechaObjeto = new Date(objeto.ValueDate);
          return (
            fechaObjeto >= new Date(this.periodInitialDate) &&
            fechaObjeto <= new Date(this.periodEndDate)
          );
        });
      }

      if (this.arrTrades.length <= environment.defaultValues.tuplesNumber) {
        this.tableMoreOfTen = false;
        //this.arrTrades = this.profilePortfolioService.portfolioanalysisTradesSource.getValue();
      } else {
        this.tableMoreOfTen = true;
        this.arrTradesTables = [];
        this.tradesTablesIndex = 0;
        let tables = Math.ceil(
          this.arrTrades.length / environment.defaultValues.tuplesNumber
        );
        for (let index = 0; index < tables; index++) {
          this.arrTradesTables[index] = [];
          this.arrTrades.forEach((trade, ind) => {
            if (
              ind >= index * environment.defaultValues.tuplesNumber &&
              ind < (index + 1) * environment.defaultValues.tuplesNumber
            ) {
              this.arrTradesTables[index].push(trade);
            }
          });
        }
        this.arrTrades = [];
        this.arrTrades = this.arrTradesTables[0];
        //this.tableMoreOfTen = true;
      }

      this.dataTrades = this.agruparPorMesAnio(
        this.arrTrades,
        this.translate.currentLang
      );
    } else {
      this.timer50.subscribe(() => {
        this.loadTrades();
      });
    }
  }

  agruparPorMesAnio(
    data: any[],
    locale: string = 'es-ES'
  ): { groupDate: string; data: any[] }[] {
    const grupos: { [key: string]: any[] } = {};
    const resultado: { groupDate: string; data: any[] }[] = [];
    const formatter = new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: 'long',
    });

    for (const item of data) {
      const fecha = new Date(item.ValueDate);
      const formattedDate = formatter.format(fecha);
      const groupDate =
        formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1); // Capitalizar la primera letra

      if (!grupos[groupDate]) {
        grupos[groupDate] = [];
      }

      grupos[groupDate].push(item);
    }

    for (const key in grupos) {
      if (grupos.hasOwnProperty(key)) {
        resultado.push({ groupDate: key, data: grupos[key] });
      }
    }

    return resultado;
  }

  public selectChange(event) {
    this.loadingTrades = true;
    let productNamesFilterchange;
    let toFilter: any =
      this.profilePortfolioService.portfolioanalysisTradesSource.getValue();

    toFilter = toFilter.filter((objeto) => {
      const fechaObjeto = new Date(objeto.ValueDate);
      return (
        fechaObjeto >= new Date(this.periodInitialDate) &&
        fechaObjeto <= new Date(this.periodEndDate)
      );
    });

    if (this.selectedProductName == '0' && this.selectedTrade == '0') {
      productNamesFilterchange = toFilter;
    } else if (this.selectedProductName != '0' && this.selectedTrade != '0') {
      productNamesFilterchange = toFilter.filter(
        (i) =>
          i.ProductName === this.selectedProductName &&
          i.TradeName === this.selectedTrade
      );
    } else if (this.selectedProductName != '0') {
      productNamesFilterchange = toFilter.filter(
        (i) => i.ProductName === this.selectedProductName
      );
    } else if (this.selectedTrade != '0') {
      productNamesFilterchange = toFilter.filter(
        (i) => i.TradeName === this.selectedTrade
      );
    }

    this.tableMoreOfTen = false;
    this.loadingTrades = false;
    this.arrTrades = productNamesFilterchange;

    if (
      productNamesFilterchange.length <= environment.defaultValues.tuplesNumber
    ) {
      this.tableMoreOfTen = false;
      this.loadingTrades = false;
      this.arrTrades = productNamesFilterchange;
    } else {
      this.tableMoreOfTen = true;
      this.arrTradesTables = [];
      this.tradesTablesIndex = 0;
      let tables = Math.ceil(
        productNamesFilterchange.length / environment.defaultValues.tuplesNumber
      );
      for (let index = 0; index < tables; index++) {
        this.arrTradesTables[index] = [];
        productNamesFilterchange.forEach((trade, ind) => {
          if (
            ind >= index * environment.defaultValues.tuplesNumber &&
            ind < (index + 1) * environment.defaultValues.tuplesNumber
          ) {
            this.arrTradesTables[index].push(trade);
          }
        });
      }
      this.loadingTrades = false;
      this.arrTrades = this.arrTradesTables[0];
    }

    this.dataTrades = this.agruparPorMesAnio(
      this.arrTrades,
      this.translate.currentLang
    );
  }

  public panelOpened(event) {
    let newTrades = this.arrTrades;
    this.loadingTrades = true;
    ++this.tradesTablesIndex;
    this.arrTradesTables[this.tradesTablesIndex].forEach((val) => {
      newTrades.push(val);
    });
    this.arrTrades = [];
    this.loadingTrades = false;
    this.arrTrades = newTrades;
    if (this.tradesTablesIndex == this.arrTradesTables.length - 1)
      this.tableMoreOfTen = false;

    this.dataTrades = this.agruparPorMesAnio(
      this.arrTrades,
      this.translate.currentLang
    );
  }

  openDialog(PeriodInitialDate, PeriodEndDate) {
    const dialogRef = this.dialog.open(ModalCustomDateTradesComponent, {
      data: {
        initialDate: PeriodInitialDate,
        endDate: PeriodEndDate,
        minDate: this.minDate,
        maxDate: this.maxDate,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.periodInitialDate = formatDate(
          result.initialDate,
          'yyyy-MM-dd',
          'en_GR'
        );
        this.periodEndDate = formatDate(result.endDate, 'yyyy-MM-dd', 'en_GR');
        this.selectChange(null);
        //this.profilePortfolioService.periodSelectedSource.next(customPeriod);
      }
    });
  }
}
